angular.module('inspinia').factory('attributesService', function () {
  let state = {
    attributes: [],
    nameValueAttributes: {},
  };

  // Getters

  /**
   * @returns attributes
   */
  const getAttributes = () => {
    return state.attributes;
  };

  const usePackplan = () => {
    return parseInt(state.nameValueAttributes.packplan_use, 10) === 1;
  };

  const isMainFacility = () => {
    return parseInt(state.nameValueAttributes.su_is_test_account, 10) === 1;
  };

  // Mutations

  /**
   * @param {*} attributes
   */
  const setAttributes = (attributes) => {
    state.attributes = attributes;
    state.nameValueAttributes = Object.fromEntries(attributes.map((attr) => [attr.name, attr.value]));
  };

  // Actions

  // $injector.get('facilityService')

  return {
    ...state,
    getAttributes,
    usePackplan,
    isMainFacility,
    setAttributes,
  };
});
